import { render, staticRenderFns } from "./coach_manage.vue?vue&type=template&id=a1c48372&"
import script from "./coach_manage.vue?vue&type=script&lang=js&"
export * from "./coach_manage.vue?vue&type=script&lang=js&"
import style0 from "./coach_manage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "coach_manage.vue"
export default component.exports